import { render, staticRenderFns } from "./UpdateCommissionDialog.vue?vue&type=template&id=5fe241dd&scoped=true"
import script from "./UpdateCommissionDialog.vue?vue&type=script&lang=js"
export * from "./UpdateCommissionDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe241dd",
  null
  
)

export default component.exports